import { toast } from "react-toastify";
import { UPLOAD_FILE } from "../services/ApiCalls";
import { catchAsync } from "./utilities";

const allowedExtensions = ["svg", "jpg", "png", "jpeg"];

// Get image width & height
const getImageMeta = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      });
      URL.revokeObjectURL(url);
    };

    img.onerror = reject;
    img.src = url;
  });

export default catchAsync(async (files) => {
  const formData = new FormData();
  const metaList = [];

  for (let index = 0; index < files.length; index++) {
    const file = files[index];
    const mimeType = file?.type || "";
    const fileType = mimeType.split("/")[1];

    if (!allowedExtensions.includes(fileType)) {
      toast.dismiss();
      toast.error(
        "Unsupported file type. Only SVG, JPG, PNG, and JPEG files are allowed."
      );
      return false;
    }

    const { width, height } = await getImageMeta(file);

    metaList.push({
      type: mimeType.startsWith("video/") ? "video" : "image",
      width,
      height,
      size: file.size,
      thumbWidth: width,
      thumbHeight: height,
      thumbSize: file.size,
    });

    formData.append("files", file);
  }

  // send meta if backend needs it
  formData.append("meta", JSON.stringify(metaList));

  const res = await UPLOAD_FILE(formData);

  if (res?.status === 200) {
    return res.data.data.files.map((url, index) => ({
      url,
      ...metaList[index],
    }));
  }

  toast.error(res?.data?.message || res?.response?.data?.message);
  return false;
});
